var _ellipse, _circle, _circle2, _circle3, _circle4, _circle5, _path, _g, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 37,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.417,
    cy: 9,
    fill: "#64BE3C",
    rx: 5,
    ry: 5.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.917,
    cy: 9,
    r: 5.5,
    fill: "#FF3C78"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.417,
    cy: 7.5,
    r: 5,
    fill: "#FF9428"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.417,
    cy: 1.5,
    r: 1,
    fill: "#7CE29F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.417,
    cy: 3.5,
    r: 1,
    fill: "#F8F8F8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.417,
    cy: 4.5,
    r: 1,
    fill: "#FFF48F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2132_31515",
    width: 31,
    height: 31,
    x: 0,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2132_31515)",
    d: "M23.47 36.5H6.52C2.933 36.5 0 33.607 0 30.071v-.214l.652-17.143C.761 9.18 3.694 6.5 7.172 6.5h15.645c3.477 0 6.411 2.679 6.52 6.214l.652 17.143c.108 1.714-.544 3.322-1.739 4.607S25.425 36.5 23.687 36.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2132_31515)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_2132_31515)",
    d: "m-1.792 18.699 33.74 19.485 26.258-15.156-59.998-34.642z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_2132_31515)",
    d: "M-1.792 44.72c0 5.764 6.239 9.357 11.22 6.475l22.521-13.01L-1.803 18.7v26.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_2132_31515)",
    d: "M73.244 1.383 9.427-35.465c-4.993-2.881-11.22.724-11.22 6.476v17.362l60.01 34.642 15.038-8.68c4.993-2.883 4.993-10.082 0-12.952z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.995 15.894c-3.585 0-6.434-2.81-6.434-6.344 0-.544.367-.906.919-.906.551 0 .918.362.918.906 0 2.537 2.023 4.531 4.596 4.531s4.595-1.994 4.595-4.531c0-.544.367-.906.919-.906.551 0 .919.362.919.906 0 3.534-2.85 6.344-6.434 6.344z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2132_31515)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M11.796 29.5v-1.82h-4.83v-1.428l4.591-6.552h2.03v6.426h1.289v1.554h-1.288v1.82zm-2.912-3.374h3.024v-4.452zm10.858 3.542q-1.008 0-1.82-.35a3.24 3.24 0 0 1-1.302-1.022 2.54 2.54 0 0 1-.476-1.526q0-.896.462-1.568.477-.672 1.246-.966a2.5 2.5 0 0 1-1.064-.84 2.12 2.12 0 0 1-.392-1.246q0-.7.378-1.288.378-.601 1.12-.966.756-.364 1.848-.364t1.834.364 1.12.966q.378.588.378 1.288 0 .672-.406 1.246a2.4 2.4 0 0 1-1.05.84q.784.294 1.246.966t.462 1.568q0 .868-.476 1.526-.476.659-1.302 1.022a4.5 4.5 0 0 1-1.806.35m0-5.964q.729 0 1.148-.378.42-.378.42-.966 0-.644-.42-1.008-.405-.364-1.148-.364-.756 0-1.162.364t-.406 1.008q0 .602.406.98.42.364 1.162.364m0 4.466q.896 0 1.358-.434.462-.448.462-1.12 0-.742-.49-1.162-.475-.42-1.33-.42t-1.358.42q-.49.42-.49 1.162 0 .672.462 1.12.477.434 1.386.434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2132_31515",
    x1: 15,
    x2: 15,
    y1: 6.5,
    y2: 36.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2132_31515",
    x1: -23.377,
    x2: 68.654,
    y1: -9.823,
    y2: 44.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2132_31515",
    x1: -40.549,
    x2: 36.052,
    y1: 8.607,
    y2: 56.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2132_31515",
    x1: -3.014,
    x2: 154.043,
    y1: -28.456,
    y2: 66.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6458C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#BE42B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2132_31515",
    width: 20.361,
    height: 14.136,
    x: 4.966,
    y: 17.532,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.8125 0 0 0 0 0.0677083 0 0 0 0 0.296875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2132_31515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2132_31515",
    result: "shape"
  })))));
};
export default SvgBag;